<template>
  <main class="container">
    <chat-thread-lg class="chat-thread"></chat-thread-lg>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ChatThreadLG from '@/components/chat/ChatThreadLG'
import l from '@/vendor/logger'

export default {
  name: 'Chat',

  data () {
    return {
      style: null
    }
  },

  created () {
    this.$store.dispatch('setMode', this.$route.params.mode.toUpperCase())
    this.$store.commit('setRid', this.$route.params.rid)
    this.$store.dispatch('chat/bindChat')
    this.$store.dispatch('chatOption/bindChatCss')
  },

  mounted () {
    l.d('Chat/mounted/chatCss', this.chatCss)
    const style = document.createElement('style')
    document.head.appendChild(style)
    style.type = 'text/css'
    style.setAttribute('id', 'userCreatedCss')
    style.textContent = this.chatCss
    this.style = style
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  computed: {
    ...mapState([
      'rid'
    ]),
    ...mapState('quizzes', [
      'quizzes'
    ]),
    ...mapGetters('chatOption', ['chatCss'])
  },

  methods: {
    unbind () {
      this.$store.dispatch('chat/unbindChat')
      this.$store.dispatch('chatOption/unbindChatCss')
    }
  },

  watch: {
    chatCss () {
      if (this.chatCss) {
        l.d('Chat/watch/chatCss', this.chatCss)
        this.style.textContent = this.chatCss
      } else {
        this.style = null
      }
    }
  },

  components: {
    'chat-thread-lg': ChatThreadLG
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
